
import Underline from "../../../assets/duotone/Underline.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function UnderlineIcon({ className, dataTestid = "UnderlineIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Underline data-testid={dataTestid} className={classes} {...rest} />
  );
}
